// extracted by mini-css-extract-plugin
var _1 = "CurrencyElementStyle-module__bold___gIK9d";
var _2 = "CurrencyElementStyle-module__currency-element___jgMqA";
var _3 = "CurrencyElementStyle-module__currency-element___jgMqA";
export { _1 as "bold", _2 as "currency-element", _3 as "currencyElement" }
